// Traffic source for a visit: utm_source / utm_medium / utm_campaign from the landing URL and the external
// referrer. Kept for the browser session (first touch wins, except that a link carrying utm parameters replaces an
// earlier organic visit) and sent with an application as data only. The server cleans and length-limits it.
const KEY = 'ksms_attribution';
const UTM = ['utm_source', 'utm_medium', 'utm_campaign'];

const read = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

const write = (value) => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // Storage can be unavailable (private windows, blocked site data); attribution is best effort.
  }
};

const externalReferrer = () => {
  if (!document.referrer) return null;
  try {
    const url = new URL(document.referrer);
    // Drop the query and fragment: referrers can carry search terms or tokens.
    return url.host === window.location.host ? null : `${url.origin}${url.pathname}`;
  } catch {
    return null;
  }
};

export const captureAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const utm = Object.fromEntries(UTM.map((k) => [k, (params.get(k) || '').trim().slice(0, 150) || null]));
  const referrer = externalReferrer();

  // A link that carries campaign parameters is an explicit source: it always replaces what was stored.
  if (UTM.some((k) => utm[k])) {
    write({ ...utm, referrer: referrer ? referrer.slice(0, 500) : null });
    return;
  }
  // Otherwise keep the first touch, and only record a visit that actually came from another site.
  if (!read() && referrer) write({ ...utm, referrer: referrer.slice(0, 500) });
};

// Fields to merge into an application payload (only the ones that have a value).
export const getAttribution = () => {
  const a = read();
  if (!a) return {};
  const out = {};
  for (const k of [...UTM, 'referrer']) if (a[k]) out[k] = a[k];
  return out;
};
